import { Accordion } from "react-bootstrap";
import PropTypes from "prop-types";

import EqqoVideo from "../../profile/EqqoVideo";

const SectionIntroduction = ({ text, videoUrl }) => (
	<Accordion className="my-4 section-explainer" defaultActiveKey="0">
		<Accordion.Item eventKey="0">
			<Accordion.Header>Section Explained</Accordion.Header>
			<Accordion.Body>
				{videoUrl ? <EqqoVideo className="mb-3 section-video" url={videoUrl} /> : null}
				<div dangerouslySetInnerHTML={{ __html: text }} />
			</Accordion.Body>
		</Accordion.Item>
	</Accordion>
);

SectionIntroduction.propTypes = {
	text: PropTypes.string.isRequired,
	videoUrl: PropTypes.string,
};

SectionIntroduction.defaultProps = {
	videoUrl: null,
};

export default SectionIntroduction;